import ConfirmableSpinnableButton from 'app/components/buttons/ConfirmableSpinnable'

export default ({ text = 'Pendify', dodone, pendifyDodone, updateDodone }) => {
  if (!dodone || (!dodone.isIgnored && !dodone.isOngoing)) return null

  return (
    <div className="input-group">
      <ConfirmableSpinnableButton
        className="btn btn-primary btn-block"
        onConfirm={pendifyDodone}
        isSpinning={updateDodone.isPending}
      >
        {text}
      </ConfirmableSpinnableButton>
    </div>
  )
}
